export default {
  screens: [
    {
      type: 'intro',
      title: 'Joséphine, muse de la maison',
      content:
        "Choisissant Chaumet comme joaillier officiel dès 1805, l'impératrice Joséphine devient sa grande inspiratrice.",
      idYt: 'gQZPa0SdueQ',
      videoCover: 'world/josephine/video.jpg',
      desktop: {
        cover: 'world/josephine/cover-1.jpg'
      },
      mobile: {
        cover: 'world/josephine/mobile-cover-1.jpg',
        contentStyle: { width: '95%' },
        titleStyle: { width: '60%' },
        coverStyle: {
          width: 'auto',
          width: '50%',
          bottom: '0',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      }
    },
    {
      type: 'memento',
      img: 'world/josephine/memento.jpg',
      content:
        "Née dans l'exubérance végétale de la Martinique, Joséphine conserve toute sa vie son affection pour un style exotique et coloré.<br/><br/>De son goût inné pour l'art, la mode, la décoration et la botanique, elle s'imposera comme la référence de son époque.",
      cover: 'world/josephine/cover-2.jpg'
    },
    {
      type: 'shadow',
      desktop: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/cover-3.jpg'
      },
      mobile: {
        middleImg: 'home/world/josephine.jpg',
        leftImg: 'world/josephine/shadowLeft.jpg',
        cover: 'world/josephine/mobile-cover-3.jpg',
        coverStyle: {
          width: '62%',
          top: '41%',
          left: '-19%',
          right: 'inherit',
          position: 'absolute'
        }
      },
      content:
        "L'art du style de Joséphine n'a cessé d'infuser les créations de Chaumet, jusqu'à inspirer la collection éponyme qui  détourne le diadème en bague."
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/fr/worlds/josephine.js